import { render, staticRenderFns } from "./tasksTodayWork.vue?vue&type=template&id=a8c650a0&"
import script from "./tasksTodayWork.vue?vue&type=script&lang=js&"
export * from "./tasksTodayWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports